export const areaNumOptions = [
  { label: '台灣+886', value: '+866' },
  { label: '香港+852', value: '+852' },
  { label: '澳門+853', value: '+853' },
  { label: '新加坡+65', value: '+65' },
  { label: '馬來西亞+60', value: '+60' },
]
